import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [CommonModule, HeaderComponent, SidebarComponent, BreadcrumbComponent, RouterOutlet, ToastModule],
  templateUrl: './app-shell.component.html',
  styleUrl: './app-shell.component.scss',
})
export class AppShellComponent implements OnInit, OnDestroy {
  private readonly collapsedStorageKey = 'nrpc_sidebar_collapsed';
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly destroy$ = new Subject<void>();
  protected readonly sidebarCollapsed = signal(localStorage.getItem(this.collapsedStorageKey) === 'true');
  protected readonly mobileSidebarOpen = signal(false);
  protected readonly routeLoading = signal(false);

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.routeLoading.set(true);
      }

      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.routeLoading.set(false);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSidebar(): void {
    this.sidebarCollapsed.update((value) => {
      const nextValue = !value;
      localStorage.setItem(this.collapsedStorageKey, String(nextValue));
      return nextValue;
    });
  }

  openMobileSidebar(): void { this.mobileSidebarOpen.set(true); }
  closeMobileSidebar(): void { this.mobileSidebarOpen.set(false); }

  logout(): void {
    this.authService.logout();
    this.closeMobileSidebar();
    this.router.navigate(['/login']);
  }
}
